import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import {Map} from 'immutable';
import {TicketModel} from '/chat/src/redux/model'
import Customization from '/chat/src/redux/model/customization/model';

import Message from './Message';
import MetaMessage from './MetaMessage';

class MessageList extends Component {
    render() {
        return (
            <div class='message-list'>
                {this.props.room && this.renderMessageList().toJS()}
            </div>)
    }

    renderMessageList() {
        // we got this when we in a new conversation
        const entries = this.props.entries
        if(!entries || !entries.size) return Map();
        const visitor = this.props.visitor
        return entries.map((entry, index) => {
            if(!entry) return null
            const meta = entry.get('meta')
            // we work with online_formular normaly
            if(meta && meta.get('type') !== 'online_formular'){
                return <MetaMessage
                    entry={TicketModel.__digestMetaEntry(entry)}
                    user={visitor}
                    />
            }
            return (
                <Message
                    entry={entry}
                    index={index}
                    color={this.props.color}
                    visitor={this.props.visitor}
                    conversation={this.props.conversation}
                    employees={this.props.employees}

                    previousEntry={entries.get(index-1)}
                    nextEntry={entries.get(index+1)}
                />
            );
        });
    }
}

function mapStateToProps(state) {
    const room = TicketModel.getCurrentRoom(state)
    const entries = TicketModel.getEntries(room, state)
    const conversation = TicketModel.get(room, state)
    const employees = state.getIn(['company', 'employees'])
    const color = Customization.getColor(state)
    const visitor = state.get('user')
    return {entries, color, visitor, conversation, employees, room};
}

export default connect(mapStateToProps)(MessageList);



// WEBPACK FOOTER //
// ./routes/Chat/Chat/MessageList.js